import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import Menu from './Menu';

const Navigation = ({ onVideoClick }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    // Scroll detection for Nav
    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 50);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <>
            <motion.nav
                initial={{ y: -100 }}
                animate={{ y: 0 }}
                transition={{ delay: 0.2, duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
                className={`fixed top-0 w-full z-50 px-6 md:px-12 py-6 flex justify-between items-center transition-all duration-500 ${scrolled ? 'mix-blend-difference py-4' : 'py-6'}`}
            >
                <Link
                    to="/"
                    className="z-50 group"
                    onClick={() => {
                        setMenuOpen(false);
                        if (window.location.pathname === '/') {
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                        }
                    }}
                >
                    <span className="font-migra text-2xl italic tracking-wide group-hover:opacity-70 transition-opacity">zxenxi.</span>
                </Link>

                {/* Desktop Links */}
                <div className="hidden md:flex gap-8 text-xs uppercase tracking-[0.2em] font-medium mix-blend-difference">
                    {['Work', 'About', 'Services', 'Contact'].map((item) => {
                        const isAbout = item === 'About';
                        const path = isAbout ? '/about' : `/#${item.toLowerCase()}`;

                        return (
                            <HashLink
                                key={item}
                                to={path}
                                smooth={!isAbout}
                                className="hover:opacity-50 transition-opacity cursor-pointer"
                            >
                                {item}
                            </HashLink>
                        )
                    })}
                </div>

                {/* Menu Toggle (Dots) */}
                <button
                    onClick={() => setMenuOpen(!menuOpen)}
                    className="z-50 grid grid-cols-3 gap-1 p-2 cursor-pointer nav-toggle mix-blend-difference"
                    aria-label="Menu"
                >
                    {[...Array(9)].map((_, i) => <div key={i} className="nav-dot bg-white"></div>)}
                </button>
            </motion.nav>

            <Menu
                isOpen={menuOpen}
                onClose={() => setMenuOpen(false)}
                onVideoClick={onVideoClick}
            />
        </>
    );
};

export default Navigation;
